import React from "react";
import { Link } from "react-router-dom";

const BookNowBanner = () => {
  return (
    <div className="container mx-auto px-4 lg:px-8 bg-primary-dark-600 rounded-xl shadow-lg py-8  my-24 xl:my-36">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between w-full h-full">
        <aside className="prose text-white">
          <h1 className="text-white">
            {/* booking available */}
            Réservation Disponible
          </h1>
          <p className="-mt-4">
            Découvrez les sommets majestueux et les sentiers enchanteurs du
            Népal en réservant votre trek avec notre équipe expérimentée !
          </p>
        </aside>
        <section className="mt-14 lg:mt-0">
          <Link
            to={"/booking"}
            //   state={{
            //     id: props.pkg_id,
            //     title: props.title,
            //   }}
            className="bg-optional p-6 text-white font-semibold rounded"
          >
            {/* Start Booking Process */}
            commencer le processus de réservation
          </Link>
        </section>
      </div>
    </div>
  );
};

export default BookNowBanner;
